
import {DragHintManager} from "./DragHintManager";
import {EventManager} from "shared/utilities/Events/EventManager";
import {OpenProperties} from "../../Events/OpenProperties";
import {PDFControlBase} from "InternalShared/PageBuilder/Controls/Core/PDFControlBase";
import {PDFDocument} from "PageBuilder/pagebuilder/PDFDocument";
import {IPDFContainer} from "InternalShared/PageBuilder/Controls/Core/IPDFContainer";
import {ControlBase} from "shared/controls/base/ControlBase";
import {GroupManager} from "InternalShared/PageBuilder/DragAndDrop/GroupManager";


export class DragManager{
    private dragDeltaX=0;
    private dragDeltaY=0;
    private originalX=0;
    private originalY=0;
    private dragging=false;
    private clicked=false;
    private $body:JQuery;
    public lastResizeDirection:ResizeDirection;
    private clickedResizeDirection:ResizeDirection;

    private resizeOriginalOffset;
    private resizeOriginalWidth;
    private resizeOriginalHeight;
    private resizeOriginalTop;
    private resizeOriginalLeft;
    private resizeContainerOffset;
    private resizeContainerWidth;
    private resizeContainerHeight;

    private ResizeUpdateTimeOut=null;

    public OnDragDrop:(event:DragDropEvent)=>void;
    public RunnableElement:PDFControlBase;
    public $element:JQuery;
    private page:IPDFContainer;
    private dragHint:DragHintManager;
    constructor(page:IPDFContainer, element:PDFControlBase)
    {
        this.dragHint=new DragHintManager(page);
        this.page=page;
        this.RunnableElement=element;
        this.$element=element.$element;
        this.$body=jQuery('body');
        this.$element.mousedown((event)=>this.OnMouseDown(event));
       // this.$element.mouseup((event)=>this.OnMouseUp(event));
        this.$element.mousemove((event)=>this.OnMouseMove(event));
        this.$element.mouseleave((event)=>this.OnMouseLeave(event));

        this.InternalOnDragMove=this.InternalOnDragMove.bind(this);
        this.InternalOnDragDrop=this.InternalOnDragDrop.bind(this);
        this.OnResizeMove=this.OnResizeMove.bind(this);
        this.OnResizeEnd=this.OnResizeEnd.bind(this);
      

    }

    private OnMouseDown(event: any) {
        event.preventDefault();
        event.stopPropagation();
        let offset=this.$element.offset();
        this.dragDeltaX=event.pageX-offset.left;
        this.dragDeltaY=event.pageY-offset.top;
        this.originalX=event.pageX;
        this.originalY=event.pageY;
        if(this.lastResizeDirection!=null)
        {
            this.originalX-=this.dragDeltaX;
            this.originalY-=this.dragDeltaY;
            this.resizeContainerOffset=this.$element.parent().offset();
            this.resizeContainerWidth=this.$element.parent().width();
            this.resizeContainerHeight=this.$element.parent().height();
            this.resizeOriginalOffset=this.$element.offset();
            this.resizeOriginalHeight=this.$element.outerHeight();
            this.resizeOriginalWidth=this.$element.outerWidth();
            this.resizeOriginalTop=parseInt(this.$element.css('top'),10);
            this.resizeOriginalLeft=parseInt(this.$element.css('left'),10);

            this.clickedResizeDirection=this.lastResizeDirection;
            jQuery(window)
                .on('mousemove',this.OnResizeMove)
                .on('mouseup',this.OnResizeEnd);
            return;
        }
        else{
            let mouseMove=(event)=>
                                {
                                    let x = event.pageX;
                                    let y = event.pageY;
                                    if(!this.dragging) {
                                        if (Math.abs(this.originalX - x) > 5 || Math.abs(this.originalY - y) > 5) {
                                            if(PDFControlBase.SelectedElements.indexOf(this.RunnableElement)>=0&&PDFControlBase.SelectedElements.length>1)
                                            {
                                                jQuery(window)
                                                    .off('mousemove',mouseMove)
                                                    .off('mouseup',mouseUp);

                                                GroupManager.Current.HandleGroupMovement(event);
                                                return;
                                            }

                                            if(!this.RunnableElement.Options.Lock) {
                                                this.dragging = true;
                                                jQuery(window)
                                                    .on('mousemove', this.InternalOnDragMove)
                                                    .on('mouseup', this.InternalOnDragDrop);
                                            }
                                        }
                                    }
                                };


            let mouseUp=(event)=>{
                this.clicked=false;
                this.lastResizeDirection=null;
                jQuery(window)
                    .off('mousemove',mouseMove)
                    .off('mouseup',mouseUp);

                PDFControlBase.ClearSelection();
                this.RunnableElement.Select();
                EventManager.Publish(new OpenProperties(this.RunnableElement));
            };

            jQuery(window)
                .on('mousemove',mouseMove)
                .on('mouseup',mouseUp);
        }

        this.clicked=true;
    }


    private OnResizeMove(event:any){
        let offset=this.$element.offset();
        let newTop=-1;
        let newLeft=-1;
        let newWidth=-1;
        let newHeight=-1;
        let width=this.$element.outerWidth();
        let height=this.$element.outerHeight();

        if(this.clickedResizeDirection=='tr'||this.clickedResizeDirection=="tl"||this.clickedResizeDirection=="t")
        {
            let pageY=Math.max(event.pageY,this.resizeContainerOffset.top);
            let deltaY=Math.ceil(pageY-this.originalY);
            if(deltaY<0||this.resizeOriginalHeight-deltaY>30)
            {
                newTop=this.resizeOriginalTop+deltaY;
                newHeight=this.resizeOriginalHeight+deltaY*-1;
            }
        }

        if(this.clickedResizeDirection=='tl'||this.clickedResizeDirection=="l"||this.clickedResizeDirection=="bl")
        {
            let pageX=Math.max(event.pageX,this.resizeContainerOffset.left);
            let deltaX=Math.ceil(pageX-this.originalX);
            if(deltaX<0||this.resizeOriginalWidth-deltaX>30)
            {
                newLeft=this.resizeOriginalLeft+deltaX;
                newWidth=this.resizeOriginalWidth+deltaX*-1;
            }


        }

        if(this.clickedResizeDirection=='bl'||this.clickedResizeDirection=="b"||this.clickedResizeDirection=="br")
        {
            let pageY=Math.min(event.pageY,this.resizeContainerOffset.top+this.resizeContainerHeight);
            let deltaY=Math.ceil(pageY-this.originalY);
            deltaY-=this.resizeOriginalHeight;
            if(deltaY>0||this.resizeOriginalHeight+deltaY>30)
            {
                newHeight=this.resizeOriginalHeight+deltaY;
            }
        }

        if(this.clickedResizeDirection=='tr'||this.clickedResizeDirection=="r"||this.clickedResizeDirection=="br")
        {
            let pageX=Math.min(event.pageX,this.resizeContainerOffset.left+this.resizeContainerWidth);
            let deltaX=Math.ceil(pageX-this.originalX);
            deltaX-=this.resizeOriginalWidth;
            if(deltaX>0||this.resizeOriginalWidth+deltaX>30)
            {
                newWidth=this.resizeOriginalWidth+deltaX;
            }
        }


        if(newTop>=0) {
            this.$element.css({top: newTop});
            this.RunnableElement.Options.Styles.Top=newTop+'px';
        }
        if(newHeight>=0) {
            this.$element.css({height: newHeight});
            this.RunnableElement.Options.Styles.Height=newHeight+'px'
        }

        if(newLeft>=0) {
            this.$element.css({left: newLeft});
            this.RunnableElement.Options.Styles.Left=newLeft+'px'
        }
        if(newWidth>=0) {
            this.$element.css({width: newWidth});
            this.RunnableElement.Options.Styles.Width=newWidth+'px';
        }


        this.FireResizeUpdate();

    }

    private OnResizeEnd(event:any){
        jQuery(window)
            .off('mousemove',<any>this.OnResizeMove)
            .off('mouseup',this.OnResizeEnd);
    }



    private OnMouseMove(event: any) {
        let x = event.pageX;
        let y = event.pageY;
        if(!this.clicked)
        {
            let resizeDirection=this.GetResizeDirection(x,y);
            let cursor;
            if(resizeDirection==null)
                cursor='';
            else if (resizeDirection=="t")
                cursor='n-resize';
            else if (resizeDirection=="tr")
                cursor='ne-resize';
            else if (resizeDirection=="r")
                cursor='e-resize';
            else if (resizeDirection=="br")
                cursor='se-resize';
            else if (resizeDirection=="b")
                cursor='s-resize';
            else if (resizeDirection=="bl")
                cursor='sw-resize';
            else if (resizeDirection=="l")
                cursor='w-resize';
            else if (resizeDirection=="tl")
                cursor='nw-resize';
            this.$body.css('cursor',cursor);
            this.$element.css('cursor',cursor);
            this.lastResizeDirection=resizeDirection;
        }


    }

    private InternalOnDragMove(event:any){
        let x=event.pageX-this.originalX;
        let y=event.pageY-this.originalY;

        let additionalPixels=this.dragHint.ShowIfNeeded(this.RunnableElement.$element,{
           left:event.pageX-this.dragDeltaX,
           top:event.pageY-this.dragDeltaY,
           width:this.RunnableElement.latestDimension.width,
           height:this.RunnableElement.latestDimension.height
        });

        if(event.altKey==false) {
            x -= additionalPixels.left;
            y -= additionalPixels.top;
        }
        this.$element.data('drag-x',x);
        this.$element.data('drag-y',y);
        this.$element[0].style.webkitTransform = this.$element[0].style.transform ='translateX(' + x + 'px) translateY(' + y + 'px)';
    }

    private InternalOnDragDrop(event:any)
    {
        this.dragHint.Clear();
        this.dragging=false;
        this.clicked=false;
        jQuery(window)
            .off('mousemove',this.InternalOnDragMove)
            .off('mouseup',this.InternalOnDragDrop);

        event.dragDeltaX=this.dragDeltaX;
        event.dragDeltaY=this.dragDeltaY;
        event.cancel=false;
        event.cancelAnimation=false;
        this.OnDragDrop(event);
        if(event.cancel==true)
        {
            if(!event.cancelAnimation) {
                let x = this.$element.data('drag-x');
                let y = this.$element.data('drag-y');
                this.$element.velocity({translateX: [0, x], translateY: [0, y]}, 200, "easeInExp");
            }
        }

        //this.Drop(event,dragDeltaX,dragDeltaY)
    }

    private GetResizeDirection(x: number, y: number):ResizeDirection {
        if(this.RunnableElement.AllowedResizeDirection=="none")
            return null;
        let offset=this.$element.offset();
        let width=this.$element.outerWidth();
        let height=this.$element.outerHeight();
        const resizeGap=10;
        if(x<offset.left||x>offset.left+width||y<offset.top||y>offset.top+height)
            return null;

        if(y<offset.top+resizeGap&&(this.RunnableElement.AllowedResizeDirection=="vertical"||this.RunnableElement.AllowedResizeDirection=="both"))
        {
            if(this.RunnableElement.AllowedResizeDirection=="vertical")
                return 't';
            if(x<offset.left+resizeGap)
                return "tl";
            if(x>offset.left+width-resizeGap)
                return "tr";
            return "t";
        }


        if(y>offset.top+height-resizeGap&&(this.RunnableElement.AllowedResizeDirection=="vertical"||this.RunnableElement.AllowedResizeDirection=="both"))
        {
            if(this.RunnableElement.AllowedResizeDirection=="vertical")
                return 'b';
            if(x<offset.left+resizeGap)
                return "bl";
            if(x>offset.left+width-resizeGap)
                return "br";
            return "b";
        }

        if(x<offset.left+resizeGap&&(this.RunnableElement.AllowedResizeDirection=="horizontal"||this.RunnableElement.AllowedResizeDirection=="both"))
            return 'l';

        if(x>offset.left+width-resizeGap&&(this.RunnableElement.AllowedResizeDirection=="horizontal"||this.RunnableElement.AllowedResizeDirection=="both"))
            return 'r';

        return null;


    }

    private OnMouseLeave(event: any) {
        this.$body.css('cursor','');
        this.$element.css('cursor','')

    }

    private FireResizeUpdate() {
        this.RunnableElement.AfterResize();
    }

}

export interface DragDropEvent{
    cancel:boolean;
    cancelAnimation:boolean;
    dragDeltaX:number;
    dragDeltaY:number;
    pageX:number;
    pageY:number;
    clientX:number;
    clientY:number;
}

type ResizeDirection="t"|"tl"|"l"|"bl"|"b"|"br"|"r"|"tr";